import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Group = _resolveComponent("Group");
    const _component_v_card = _resolveComponent("v-card");
    const _component_FeeSetting = _resolveComponent("FeeSetting");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_card, { class: "brg-card-outlined group-wrapper allocated-cancel-penalty-group-setting-outer first" }, {
                default: _withCtx(() => [
                    _createVNode(_component_Group)
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card, { class: "brg-card-outlined fee-wrapper allocated-cancel-penalty-group-setting-outer" }, {
                default: _withCtx(() => [
                    _createVNode(_component_FeeSetting)
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
            class: "list-btn mt-4",
            onClick: _ctx.handleClickBackToListBtn
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_icon, { small: "" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" mdi-chevron-left ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [0]
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.lc}back_to_list`)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])), [
            [
                _directive_btn_style,
                void 0,
                "config",
                {
                    info: true,
                    outlined: true,
                    "size-l": true,
                    "width-xs": true
                }
            ]
        ])
    ]));
}
